<template>
  <div class="home page-wrapper">
    <div class="container-xl mb-2">
      <!-- Page title -->
      <div class="page-header d-print-none">
        <div class="row align-items-center">
          <div class="col">
            <!-- Page pre-title -->
            <div class="page-pretitle">
              {{ $auth.activeCompany.companyName }}
            </div>
            <h2 class="page-title">Lead Orders</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body" v-if="loaded && (activeLeadOrders.length > 0 || completedLeadOrders.length > 0)">
      <div class="container-xl">
        <div class="row row-deck row-cards">
          <div class="table-responsive mb-4" v-if="activeLeadOrders.length">
            <h3>Active Lead Orders</h3>
            <table class="table table-vcenter card-table table-striped">
              <thead>
                <tr>
                  <th>
                    <a href="#">
                      Lead Order Name
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Lead Quantity
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Leads Received
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Start Date
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Actions
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="leadOrder in activeLeadOrders" v-bind:key="leadOrder.id">
                  <td>
                    <div class="text-left text-nowrap">
                      {{ leadOrder.name }}
                    </div>
                  </td>
                  <td>
                    <div class="text-left text-nowrap">
                      {{ leadOrder.leadQuantity }}
                    </div>
                  </td>
                  <td>
                    <div class="text-left text-nowrap">
                      {{ leadOrder.leadsReceived }}
                    </div>
                  </td>
                  <td>
                    <div class="text-left text-nowrap">
                      {{ formatDate(leadOrder.startDate) }}
                    </div>
                  </td>
                  <td>
                    <router-link class="btn btn-sm" :to="`/lead-orders/${leadOrder.id}`">
                      <!-- SVG icon from http://tabler-icons.io -->
                      Details
                      <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-bounce ms-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 18h4" /><path d="M3 8a9 9 0 0 1 9 9v1l1.428 -4.285a12 12 0 0 1 6.018 -6.938l.554 -.277" /><path d="M15 6h5v5" /></svg>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive" v-if="completedLeadOrders.length">
            <h3>Completed Lead Orders</h3>
            <table class="table table-vcenter card-table table-striped">
              <thead>
                <tr>
                  <th>
                    <a href="#">
                      Lead Order Name
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Lead Quantity
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Leads Received
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Start Date
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Complete Date
                    </a>
                  </th>
                  <th class="text-left text-nowrap">
                    <a href="#">
                      Actions
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="leadOrder in completedLeadOrders" v-bind:key="leadOrder.id">
                  <td>
                    <div class="text-left text-nowrap">
                      {{ leadOrder.name }}
                    </div>
                  </td>
                  <td>
                    <div class="text-left text-nowrap">
                      {{ leadOrder.leadQuantity }}
                    </div>
                  </td>
                  <td>
                    <div class="text-left text-nowrap">
                      {{ leadOrder.leadsReceived }}
                    </div>
                  </td>
                  <td>
                    <div class="text-left text-nowrap">
                      {{ formatDate(leadOrder.startDate) }}
                    </div>
                  </td>
                  <td>
                    <div class="text-left text-nowrap">
                      {{ formatDate(leadOrder.completeDate) }}
                    </div>
                  </td>
                  <td>
                    <router-link class="btn btn-sm" :to="`/lead-orders/${leadOrder.id}`">
                      <!-- SVG icon from http://tabler-icons.io -->
                      Details
                      <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-bounce ms-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 18h4" /><path d="M3 8a9 9 0 0 1 9 9v1l1.428 -4.285a12 12 0 0 1 6.018 -6.938l.554 -.277" /><path d="M15 6h5v5" /></svg>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container-xl" v-else-if="loaded && activeLeadOrders.length === 0 && completedLeadOrders.length === 0">
      <span>
        Your company does not have any lead orders.
      </span>
    </div>
    <div class="container-xl" v-else>
      <div class="row">
        <div class="col">
          <h3>Preparing lead orders...</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.table .text-right {
  text-align: right;
}

.table .text-left {
  text-align: left;
}

.table .text-center {
  text-align: center;
}

.table-responsive {
  margin-bottom: 0px;
}

.home{
  min-height: calc(100vh - 310px);
}

</style>

<script>
import LeadOrderService from "../../services/LeadOrderService";
import CSVService from "../../services/CSVService";
import TrackingService from "../../services/TrackingService";
import { format, parseISO } from "date-fns";

export default {
  name: "LeadOrders",
  components: {
  },
  data: () => {
    return {
      loaded: false,
      reload: false,
      leadOrders: [],
      custom: false,
      rows: 0
    };
  },
  computed: {
    activeLeadOrders()
    {
      return this.leadOrders.filter(leadOrder => {
        return leadOrder.isComplete === false;
      });
    },
    completedLeadOrders()
    {
      return this.leadOrders.filter(leadOrder => {
        return leadOrder.isComplete === true;
      });
    }
  },
  methods: {
    formatDate(date) {
      if(!date) return "";
      return format(parseISO(date), "MM/dd/yyyy")
    },
    generateCSV() {
      TrackingService.track("download lead order export", {
        detail: `all`,
      });
      let fields = [
        {
          id: "LeadDateEST",
          getter: (r) => r["sentDate"],
        },
        {
          id: "LeadAttribution",
          getter: (r) => r["leadAttribution"],
        },
        {
          id: "LeadType",
          getter: (r) => r["reportLeadType"],
        },
        {
          id: "LeadAsset",
          getter: (r) => r["leadMagnet"],
        },
        {
          id: "DirectorySiteName",
          getter: (r) => r["siteName"],
        },
        {
          id: "FirstName",
          getter: (r) => r["leadFirstName"],
        },
        {
          id: "LastName",
          getter: (r) => r["leadLastName"],
        },
        {
          id: "Title",
          getter: (r) => r["leadTitle"],
        },
        {
          id: "EmailAddress",
          getter: (r) => r["leadEmailAddress"],
        },
        {
          id: "Company",
          getter: (r) => r["leadCompanyName"],
        },
        {
          id: "CompanySize",
          getter: (r) => r["leadNumberOfEmployees"],
        },
        {
          id: "Industry",
          getter: (r) => r["leadIndustry"],
        },
        {
          id: "PhoneNumber",
          getter: (r) => r["leadPhone"],
        },
        {
          id: "Address",
          getter: (r) => r["leadAddress"],
        },
        {
          id: "Address2",
          getter: (r) => r["leadAddress2"],
        },
        {
          id: "City",
          getter: (r) => r["leadCity"],
        },
        {
          id: "State",
          getter: (r) => r["leadState"],
        },
        {
          id: "PostalCode",
          getter: (r) => r["leadPostalCode"],
        },
        {
          id: "Country",
          getter: (r) => r["leadCountry"],
        },
        {
          id: "MessageSubject",
          getter: (r) => r["leadEmailSubject"],
        },
        {
          id: "Message",
          getter: (r) => r["leadEmailMessage"],
        },
      ];
      let csv = CSVService.serialize({
        fields: fields,
        records: this.filteredleadDTOs,
      });
      let download = document.createElement("a");
      let blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      let url = URL.createObjectURL(blob);
      download.href = url;
      download.setAttribute("download", "lead_export.csv");
      download.click();
    },
    async getLeadOrders(isreload) {
      let company = this.$auth.activeCompany;

      console.log(company);

      // mark as reload or not
      this.reload = isreload;

      // make service call
      let leadOrders = await LeadOrderService.getLeadOrders(company.companyId);

      // mark as loaded
      this.loaded = true;

      // mark as reloaded
      this.reload = false;

      this.leadOrders = leadOrders;
    },
  },
  async mounted() {
    // load lead data for company
    this.getLeadOrders(false);

    TrackingService.track("viewed lead orders page");
  },
};
</script>
